import { useState, useEffect } from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  Pagination,
  Button,
  Chip
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageHeader from 'src/components/page-header';
import { getBatchOpenData, closeBatch } from 'src/services/apiService';
import { BatchClockData } from 'src/services/apiService/response-models';

// FilterFormValues interface and validation schema removed since filters are commented out

function BatchClock() {
  const [batchData, setBatchData] = useState<BatchClockData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize] = useState(10);

 
  console.log('Environment variable REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

  // Initial values for filters (commented out)
  // const initialValues: FilterFormValues = {
  //   appRegisterId: '',
  //   employeeId: '',
  //   status: '',
  //   startDate: '',
  //   endDate: '',
  // };

  const fetchBatchData = async (filters?: any) => {
    try {
      setLoading(true);
      setError('');
      
      console.log('Fetching batch data with filters:', { ...filters, page, limit: pageSize });
      
      const response = await getBatchOpenData({
        ...filters,
        page,
        limit: pageSize,
      });
      
      console.log('API Response:', response);
      setBatchData(response.data || []);
      // Assuming the API returns pagination info, adjust as needed
      setTotalPages(Math.ceil((response.data || []).length / pageSize));
    } catch (err: any) {
      console.error('Full error object:', err);
      console.error('Error message:', err.message);
      console.error('Error response:', err.response);
      console.error('Error config:', err.config);
      
      let errorMessage = 'Failed to load batch data';
      if (err.response) {
        errorMessage = err.response.data?.message || `HTTP ${err.response.status}: ${err.response.statusText}`;
      } else if (err.request) {
        errorMessage = 'Network error: No response received from server';
      } else {
        errorMessage = err.message || 'Unknown error occurred';
      }
      
      setError(errorMessage);
      setBatchData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBatchData();
  }, [page]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleFilterSubmit = (values: any) => {
    setPage(1);
    fetchBatchData(values);
  };

  const handleCloseBatch = async (batchId: string) => {
    try {
      console.log('Closing batch:', batchId);
      await closeBatch(batchId);
      alert(`Batch ${batchId} closed successfully`);
      // Refresh the data
      fetchBatchData();
    } catch (error) {
      console.error('Error closing batch:', error);
      alert('Failed to close batch');
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'open':
        return 'primary';
      case 'closed':
        return 'success';
      case 'pending':
        return 'warning';
      default:
        return 'default';
    }
  };

  return (
    <>
      <Helmet>
        <title>Batch Clock</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          title="Batch Clock"
          subtitle="Monitor and manage batch operations"
          type="list"
          showButton={false}
        />
      </PageTitleWrapper>
      
      <Box sx={{ mt: 3, px: 4 }}>
        {/* Filter Form - Commented out for now */}
        {/* <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Filters
            </Typography>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleFilterSubmit}
            >
              {({ values, handleChange, handleSubmit, resetForm }) => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        fullWidth
                        name="appRegisterId"
                        label="Register ID"
                        value={values.appRegisterId}
                        onChange={handleChange}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        fullWidth
                        name="employeeId"
                        label="Employee ID"
                        value={values.employeeId}
                        onChange={handleChange}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="status"
                          value={values.status}
                          onChange={handleChange}
                          label="Status"
                        >
                          <MenuItem value="">All</MenuItem>
                          <MenuItem value="open">Open</MenuItem>
                          <MenuItem value="closed">Closed</MenuItem>
                          <MenuItem value="pending">Pending</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField
                        fullWidth
                        name="startDate"
                        label="Start Date"
                        type="date"
                        value={values.startDate}
                        onChange={handleChange}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField
                        fullWidth
                        name="endDate"
                        label="End Date"
                        type="date"
                        value={values.endDate}
                        onChange={handleChange}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ mr: 1 }}
                        disabled={loading}
                      >
                        Apply Filters
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm();
                          fetchBatchData();
                        }}
                        disabled={loading}
                      >
                        Clear
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card> */}

        {/* Data Table */}
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
              Batch Operations
            </Typography>
            
            {error && (
              <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}

            {loading ? (
              <Typography>Loading...</Typography>
            ) : (
              <>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="batch clock table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Batch #</TableCell>
                        <TableCell>Register ID</TableCell>
                        <TableCell>Employee</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Start Time</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {batchData.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.batchNumber}
                          </TableCell>
                          <TableCell>{row.appRegisterId}</TableCell>
                          <TableCell>
                            {row.employeeId.firstName} {row.employeeId.lastName}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={row.status}
                              color={getStatusColor(row.status) as any}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>{formatDate(row.startAt)}</TableCell>
                          <TableCell>
                            {row.status === 'open' && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => handleCloseBatch(row.id)}
                                disabled={loading}
                              >
                                Close Batch
                              </Button>
                            )}
                            {row.status !== 'open' && (
                              <Chip
                                label={row.status}
                                color="default"
                                size="small"
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination */}
                {totalPages > 1 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                      showFirstButton
                      showLastButton
                    />
                  </Box>
                )}
              </>
            )}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

export default BatchClock; 